ui-cms-slider {
  display: block;
  padding-bottom: $sd-spacing-10;

  .mgnlEditor {
    width: 100%;
  }

  sd-carousel {
    &::part(scroll-container) {
      display: flex;
      flex-direction: column;
      gap: $sd-spacing-4;
    }

    sd-carousel-item {
      > * {
        height: 100%;
        width: 100%;
      }
    }
  }
}

.mgnlEditorBar.focus,
.mgnlEditorBar.focus + ui-cms-slider > sd-carousel > sd-carousel-item > .mgnlEditorBar {
  /* stylelint-disable declaration-no-important */
  display: flex !important;
}
